export default __webpack_public_path__ + "static/media/grafema_+-identity_01.6955505e.jpg";